"use client";
import { getTranslation } from "@/i18n/get-translation";

import { ICategory, ICategoryResponse } from "@/types/category.type";
import Footer from "@components/footer/footer";
import MoveToTop from "@components/move-to-top/move-to-top";

import { useRouter, useSearchParams } from "next/navigation";
import { useCallback, useEffect, useState } from "react";
import SubHeader from "@components/sub-header/sub-header";
import SubCategories from "@components/sub-categories/sub-categories";
import NewsFeaturePosts from "@components/news-components/news-feature-post/news-feature-post";
import NewsTrendingPosts from "@components/news-components/news-trending-posts/news-trending-posts";
import NewsRecentPosts from "@components/news-components/news-recent-posts/news-recent-posts";
import InnerSubCategories from "@components/inner-sub-categories/innner-sub-categories";
import { getNewsCategories } from "@/services/news-category.service";

interface INewsMainPage {
  locale: string;
}
const init = {
  data: [],
  meta: {
    pagination: {
      page: 0,
      pageSize: 0,
      pageCount: 0,
      total: 0,
    },
  },
};
export default function NewsMainPage({ locale }: INewsMainPage) {
  const [blogCategories, setBlogCategories] = useState<ICategoryResponse>(init);
  const t = getTranslation(locale, "innerSubCategories");
  const router = useRouter();
  const searchParams = useSearchParams();
  const search = searchParams.get("category");
  const [selectedBlogCategories, setSelectedBlogCategories] =
    useState<string>("");

  const handleSelectBlogCategory = useCallback(
    (item: ICategory) => {
      if (item.id === -1) {
        setSelectedBlogCategories(t("all"));
        router.push(`/${locale}/news`);
      } else {
        setSelectedBlogCategories(item.attributes.name);
        router.push(`?category=${item.attributes.name}`);
      }
    },
    [router, locale, t]
  );
  useEffect(() => {
    const lang =
      locale.split("-")[0] === "en" ? "en" : `${locale.split("-")[0]}-LU`;
      getNewsCategories(lang)
      .then((response: ICategoryResponse) => {
        setBlogCategories(response);
      })
      .catch(console.log);
  }, [locale, router]);
  useEffect(() => {
    if (search) {
      setSelectedBlogCategories(search);
    } else {
      setSelectedBlogCategories(t("all"));
    }
  }, [search, t]);

  return (
    <>
      <InnerSubCategories
        locale={locale}
        categories={blogCategories}
        handleSelect={handleSelectBlogCategory}
        selected={selectedBlogCategories}
      />
      <NewsFeaturePosts locale={locale} />
      <NewsTrendingPosts locale={locale} />
      <NewsRecentPosts locale={locale} blogCategory={selectedBlogCategories} />
    </>
  );
}
